module.exports = __webpack_public_path__ + "static/media/empty04_sprints_anim.246dff86.svg";